import IndexSurveys from 'src/pages/Surveys/Index'
import AssociatedTicketsPrint from 'src/pages/Surveys/AssociatedTicketsPrint'

const path = 'surveys'
const title = 'Surveys'

export default {
  path: `/${path}`,
  component: IndexSurveys,
  children: [
    {
      path: `tickets-associated/:id/print`,
      name: `surveys.associated.tickets.print`,
      component: AssociatedTicketsPrint,
      meta: {
        title,
        requireAuth: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/surveys.js